<template>
  <div id="positions">
    <div class="clearfix" />

    <h2>Текущие позиции</h2>

    <div
      v-if="isMoneyReportAvailable"
      class="type-select-container"
    >
      <span class="text-gray type-select-divider">|</span><type-select v-model="type" />
    </div>

    <div
      v-if="!isPositionsReport"
      style="margin-top: 19px;"
      title="За результат"
    >
      ИТОГОВАЯ СУММА: <span
        class="text-success text-bold"
        style="font-size: 24px; padding-left: 5px;"
      >{{ round(getMoneyTotal(sengine), 1) }}</span>
    </div>

    <div class="clearfix" />

    <div class="row">
      <div class="col-md-12">
        <form class="form-inline">
          <client-projects-core-select
            label-width="60px"
            :select-width="gridSm ? '137px' : null"
          />
          <client-projects-region-select form-group-margin-bottom />
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <form class="form-inline">
          <period-range-month-select
            label-width="60px"
            :select-width="gridSm ? '137px' : null"
          />
          <period-range-from-input
            :limit-from="limitFrom"
            :limit-to="limitTo"
          />
          <period-range-to-input
            :limit-from="limitFrom"
            :limit-to="limitTo"
          />
          <sengine-select
            :value="sengine"
            :yandex-disabled="!isPromoteBySengine($getConst('SENGINE_YANDEX'))"
            :google-disabled="!isPromoteBySengine($getConst('SENGINE_GOOGLE'))"
            margin-bottom="15px"
            @input="setSengine($event)"
          />
          <positions-type-select v-if="isPositionsReport" />
          <button
            class="btn btn-success excel-download-btn"
            title="Скачать отчет в формате Excel"
            :disabled="isExportExcelDisabled"
            @click.prevent="exportExcel()"
          >
            <c-spinner v-if="excelExporting" /><i
              v-else
              class="fa fa-file-excel-o"
            /> Скачать
          </button>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <c-box
          :title="'Позиции сайта в ПС ' + getSengineName(sengine)"
          shadow
          :loading="fetching"
        >
          <positions-table v-if="isPositionsReport" />
          <money-table v-else />

          <div class="text-center hidden">
            <button class="btn background-white border-danger text-danger">
              Смотреть все позиции
            </button>
          </div>
        </c-box>
      </div>
    </div>
  </div>
</template>

<script>
import ClientProjectsRegionSelect from '../components/ClientProjectsRegionSelect'
import ClientProjectsCoreSelect from '../components/ClientProjectsCoreSelect'
import PeriodRangeMonthSelect from '../components/positions/PeriodRangeMonthSelect'
import PeriodRangeFromInput from '../components/positions/PeriodRangeFromInput'
import PeriodRangeToInput from '../components/positions/PeriodRangeToInput'
import PositionsTypeSelect from '../components/positions/PositionsTypeSelect'
import SengineSelect from '../components/SengineSelect'
import TypeSelect from '../components/positions/TypeSelect'
import CBox from '../../../../../../resources/js/components/ui/CBox'
import sengine from '../../../../../../resources/js/mixins/sengine'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import PositionsTable from '../components/positions/PositionsTable'
import MoneyTable from '../components/positions/MoneyTable'
import helper from '../../../../../../resources/js/mixins/helper'
import moment from 'moment'
import { saveFile, handleClientProjectsSelectedRegionChange } from '../../../../../../resources/js/helper'
import apiService from '../apiService'
import CSpinner from '../../../../../../resources/js/components/ui/CSpinner'
import modal from '../../../../../../resources/js/mixins/modal'
import Notification from '../../../../../../resources/js/notification'
import grid from '../../../../../../resources/js/mixins/grid'

export default {
  name: 'Positions',
  components: {
    CSpinner,
    ClientProjectsRegionSelect,
    ClientProjectsCoreSelect,
    PeriodRangeMonthSelect,
    PeriodRangeFromInput,
    PeriodRangeToInput,
    PositionsTypeSelect,
    SengineSelect,
    TypeSelect,
    CBox,
    PositionsTable,
    MoneyTable
  },
  mixins: [sengine, helper, modal, grid],
  data () {
    return {
      type: 'positions',
      excelExporting: false
    }
  },
  computed: {
    /**
     * Статус загрузки данных отчета.
     *
     * @returns {boolean}
     */
    fetching () {
      return this.type === 'positions' ? this.projectPositionsFetching : this.projectMoneyFetching
    },
    /**
     * Выбран ли в данный момент отчет по позициям.
     *
     * @returns {boolean}
     */
    isPositionsReport () {
      return this.type === 'positions'
    },
    /**
     * С какой даты можно загрузить отчет.
     *
     * @returns {null|*}
     */
    limitFrom () {
      if (this.selectedProjectId) {
        return moment(this.getSelectedProject.work_start_date).add(1, 'days')
      }

      return null
    },
    /**
     * По какую дату можно загрузить отчет.
     *
     * @returns {*}
     */
    limitTo () {
      return moment().add(1, 'days')
    },
    /**
     * Можно ли скачать отчет в формате Excel.
     *
     * @returns {boolean}
     */
    isExportExcelDisabled () {
      return this.excelExporting || !this.selectedProjectId || !this.sengine || !this.filterFrom || !this.filterTo || (this.isPositionsReport && !this.filterType)
    },
    /**
     * Доступен ли для текущего выбранного проекта (его типа продвижения) отчет по деньгам.
     *
     * @returns {boolean}
     */
    isMoneyReportAvailable () {
      return ['fix_result', 'result'].includes(this.projectType)
    },
    ...mapState({
      sengine: state => state.seo.positionsFilter.sengine,
      selectedProjectId: state => state.seo.client.projects.selectedProjectId,
      filterType: state => state.seo.positionsFilter.type,
      projectType: state => state.seo.project.type.type,
      clientAgreementsTotal: state => state.seo.client.agreements.total,
      selectedClientId: state => state.seo.projects.selectedClientId,
      filterRangeFrom: state => state.seo.positionsFilter.rangeFrom,
      projectPositionsFetching: state => state.seo.project.positions.fetching,
      projectMoneyFetching: state => state.seo.project.money.fetching,
      positionsFilterType: state => state.seo.positionsFilter.type
    }),
    ...mapGetters({
      getMoneyTotal: 'seo/project/money/getTotalValue',
      getSelectedProject: 'seo/client/projects/getSelectedProject',
      filterFrom: 'seo/positionsFilter/fetchFrom',
      filterTo: 'seo/positionsFilter/fetchTo',
      isPromoteBySengine: 'seo/client/projects/isSelectedProjectPromoteBySengine'
    })
  },
  mounted () {
    if (this.selectedProjectId) {
      this.init()
    }
    this.$root.$on('clientProjectsSelectedProjectIdChange', this.init)

    this.$root.$on('clientProjectsSelectedRegionChange', handleClientProjectsSelectedRegionChange)

    this.$root.$on('projectPositionsDataQueryChange', this.handleProjectPositionsDataQueryChange)

    if (this.selectedClientId) {
      this.fetchClientAgreements()
    }
    this.$root.$on('clientIdSelected', this.fetchClientAgreements)
    this.$root.$on('clientAgreementsLoaded', this.showAgreementsExists)
  },
  created () {
    // Проект, который только что был выбран, может иметь тип продвижения, на котором не доступен отчет по деньгам, по этому сбрасываем тип отчета.
    this.$root.$on('clientProjectsSelectedProjectIdChange', () => {
      this.type = 'positions'
    })
  },
  destroyed () {
    this.$root.$off('clientProjectsSelectedProjectIdChange', this.init)
    this.$root.$off('clientProjectsSelectedRegionChange', handleClientProjectsSelectedRegionChange)
    this.$root.$off('projectPositionsDataQueryChange', this.handleProjectPositionsDataQueryChange)
    this.$root.$off('clientIdSelected', this.fetchClientAgreements)
    this.$root.$off('clientAgreementsLoaded', this.showAgreementsExists)
  },
  methods: {
    init () {
      if (moment(this.getSelectedProject.work_start_date).isAfter(moment(this.filterRangeFrom, 'DD-MM-YYYY'))) {
        this.filterSetRangeFrom(moment(this.getSelectedProject.work_start_date))
      }

      this.setClientProjectsSelectedRegion(this.getSelectedProject.region)

      // Обновляем выбранную ПС, если в выбранном проекте нет ПС, которая в данный момент выбрана
      if (
        this.getSelectedProject.sengines.length &&
        !this.getSelectedProject.sengines.includes(this.sengine)
      ) {
        this.setPositionsFilterSengine(this.getSelectedProject.sengines[0])
      }

      this.fetchProjectPositions({
        idParent: this.selectedProjectId,
        sengine: this.sengine,
        from: this.filterFrom,
        to: this.filterTo,
        type: this.positionsFilterType
      })

      this.fetchProjectType(this.selectedProjectId)
        .then(() => {
          if (this.isMoneyReportAvailable) {
            this.fetchProjectMoney({
              idParent: this.selectedProjectId,
              sengine: this.sengine,
              from: this.filterFrom,
              to: this.filterTo
            })
          }
        })
    },
    handleProjectPositionsDataQueryChange () {
      if (!moment(this.filterFrom).isValid() || !moment(this.filterTo).isValid()) {
        return
      }

      this.fetchProjectPositions({
        idParent: this.selectedProjectId,
        sengine: this.sengine,
        from: this.filterFrom,
        to: this.filterTo,
        type: this.positionsFilterType
      })

      if (this.isMoneyReportAvailable) {
        this.fetchProjectMoney({
          idParent: this.selectedProjectId,
          sengine: this.sengine,
          from: this.filterFrom,
          to: this.filterTo
        })
      }
    },
    /**
     * Показывает уведомление о наличии задач с необходимыми работами по продвижению сайта.
     */
    showAgreementsExists () {
      if (this.clientAgreementsTotal) {
        this.showModal(this.$getConst('AGREEMENTS_EXISTS_MODAL_ID'))
      }
    },
    /**
     * Загружает и сохраняет файл отчета в формате Excel в браузере.
     */
    exportExcel () {
      this.excelExporting = true

      if (this.isPositionsReport) {
        apiService.getPositionsExport(
          this.selectedProjectId,
          this.sengine,
          this.filterFrom,
          this.filterTo,
          this.filterType
        )
          .then(response => {
            saveFile(response)

            this.excelExporting = false
          })
          .catch(() => {
            this.excelExporting = false

            Notification.notifyError({
              title: 'Ошибка',
              content: 'Не удалось загрузить файл отчета по позициям.'
            })
          })
      } else {
        apiService.getMoneyExport(
          this.selectedProjectId,
          this.sengine,
          this.filterFrom,
          this.filterTo
        )
          .then(response => {
            saveFile(response)

            this.excelExporting = false
          })
          .catch(() => {
            this.excelExporting = false

            Notification.notifyError({
              title: 'Ошибка',
              content: 'Не удалось загрузить файл отчета по деньгам.'
            })
          })
      }
    },
    /**
     * Изменяет значение выбранной поисковой системы.
     *
     * @param sengine
     */
    setSengine (sengine) {
      if (this.isPromoteBySengine(sengine) && this.sengine !== sengine) {
        this.positionsFilterChangeSengine(sengine)
      }
    },
    ...mapActions({
      fetchClientAgreements: 'seo/client/agreements/fetch',
      fetchProjectType: 'seo/project/type/fetch',
      fetchProjectPositions: 'seo/project/positions/fetch',
      fetchProjectMoney: 'seo/project/money/fetch',
      positionsFilterChangeSengine: 'seo/positionsFilter/changeSengine'
    }),
    ...mapMutations({
      filterSetRangeFrom: 'seo/positionsFilter/setRangeFrom',
      setClientProjectsSelectedRegion: 'seo/client/projects/setSelectedRegion',
      setPositionsFilterSengine: 'seo/positionsFilter/setSengine'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

h2 {
  float: left;
  margin-right: 20px;

  @media (max-width: $smBreakpoint) {
    float: none;
  }
}

.type-select-container {
  float: left;
  margin-top: 26px;
  margin-right: 20px;

  @media (max-width: $smBreakpoint) {
    float: none;
    margin-right: 0;
  }

  .type-select-divider {
    padding-right: 20px;

    @media (max-width: $smBreakpoint) {
      display: none;
    }
  }
}

.excel-download-btn {
  margin-bottom: 15px;
}
</style>

<style>
  /* глобальные стили */
  #positions .box {
    overflow-x: auto;
  }
</style>
